import { Component, OnInit } from '@angular/core';
import { EnvService } from '../../../shared/services/env.service';
import { PasswordStrengthComponent } from '../../../password-strength/password-strength.component';
import { FormBuilder, AbstractControl, FormControl, ValidationErrors, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd';
import { NzModalService } from 'ng-zorro-antd';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { RestProvider } from '../../../shared/services/rest.provider';
import { Router } from '@angular/router';
//import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-activate',
  templateUrl: './activate.component.html',
  styleUrls: ['./activate.component.css']
})
export class ActivateComponent implements OnInit {
  public href: string = "";
  public bannerLogo: any;
  public bannerHeaderText: string;
  public bannerHeaderTextColor: string;
  public bannerSubHeaderText: string;
  public bannerSubHeaderTextColor: string;
  public records : any[] = [];
  public recordsMember : any[] = [];
  public gendersList: any[] = [];
  public navLogo: string;
  public socialNavItems: any [] = [];
  uniqueId: string;
  loginUrl: string;
  detailsForm: FormGroup;
  clientId: string;
  accountId: string;
  userGUID: string;
  currentDate: any;
  formErrors: boolean;
  errorMessage: string;
  today: any;
  passwordIsValid: boolean;
  isLoaded: boolean;

  constructor(private fb: FormBuilder,
              private spinnerService: Ng4LoadingSpinnerService,
              public restProvider: RestProvider,
              public router: Router,
              private env: EnvService,
              private modalService: NzModalService,
              private message: NzMessageService) {

                this.spinnerService.show();
                const parsedUrl = new URL(window.location.href);
                const baseUrl = parsedUrl.origin;
                this.setAPIUrl(baseUrl);
                window.location.href = this.loginUrl;
  }

  ngOnInit() {}

  setAPIUrl(baseUrl){
      switch(baseUrl) {
        case 'https://talk.dev.memd.me':
          this.env.CORE_API_URL = 'https://dev-integrations.memd.me';
          localStorage.setItem('partnerUrl','https://dev-partners.memd.me');
          this.loginUrl = 'https://patient.dev.memd.me';
          break;
        case 'https://talk.staging.memd.me':
          this.env.CORE_API_URL = 'https://staging-integrations.memd.me';
          localStorage.setItem('partnerUrl','https://staging-partners.memd.me');
          this.loginUrl = 'https://patient.staging.memd.me';
          break;
        case 'https://talk.memd.me':
          this.env.CORE_API_URL = 'https://integrations.memd.me';
          localStorage.setItem('partnerUrl','https://partners.memd.me');
          this.loginUrl = 'https://patient.memd.me';
          break;
        default:
          localStorage.setItem('partnerUrl','https://dev-partners.memd.me');
          this.loginUrl = 'https://patient.dev.memd.me';
      }
  }

}
